import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useHistory } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';
import { useCookies } from 'react-cookie';
import { Box, Divider } from '@material-ui/core';
import PrimaryButton from '../../customUI/PrimaryButton';
import Sidebar from '../sidebar/Sidebar';
import GroupImage from '../groupImage/GroupImage';
import { storeContext } from '../provider/Provider';
import BlueButton from '../../customUI/BlueButton';
import logo from '../../images/logo.svg';
import horse from '../../images/horse.png';
import squareLogo from '../../images/logo-2.svg';
import funnel from '../../images/funnel-icon.svg';
import charts from '../../images/charts-icon.svg';
import network from '../../images/network-icon.svg';
import headset from '../../images/headset-icon.svg';
import MobileTitle from '../../customUI/MobileTitle';

const { REACT_APP_AUTH0_URL, REACT_APP_AUTH0_CLIENT_ID } = process.env;
/*
 * Login component is using custom Sidebar component and */

const useStyles = makeStyles(() => ({
  loginInput: {
    marginTop: 20,
  },
  label: {
    fontSize: 18,
    margin: 0,
  },
  loginForm: {
    margin: 20,
    marginBottom: 0,
  },
  loginSubmitButton: {
    width: 160,
    backgroundColor: '#00B4E0',
    height: 42,
  },
  buttonWrapper: {
    marginTop: 20,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 20,
  },
  blackLinkForgot: {
    textAlign: 'center',
    color: 'black',
    textDecoration: 'none',
    userSelect: 'none',
    cursor: 'pointer',
    fontSize: 14,
  },
  blackLinkAccount: {
    textAlign: 'center',
    color: 'black',
    textDecoration: 'none',
    userSelect: 'none',
    marginTop: 10,
    marginBottom: 5,
    cursor: 'pointer',
    fontSize: 14,
    fontWeight: 600,
  },
  greyColorCustomizer: {
    color: '#C2CFE0',
  },
  loginImage: {
    width: '100%',
    position: 'fixed',
    pointerEvents: 'none',
    objectFit: 'cover',
    objectPosition: 'center',
    height: '60vh',
  },
  backgroundContent: {
    width: '100%',
    height: '60vh',
    position: 'fixed',
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& h1': {
      margin: 0,
      color: '#00B5E2',
      fontFamily: 'Playfair',
      fontWeight: 300,
      fontSize: 25,
    },
  },
  iconContainer: {
    display: 'flex',
    justifyContent: 'center',
    '& img': {
      width: '2em',
      padding: 20,
    },
  },
  mobileFlex: {
    height: '80vh',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
}));

const Login = () => {
  const isPhone = useMediaQuery({ query: '(max-width: 768px)' });
  const [phoneEntered, setPhoneEntered] = React.useState(!isPhone);
  const [cookies ] = useCookies(['auth']);
  const { state } = React.useContext(storeContext);
  const history = useHistory();
  const classes = useStyles();
 

  

  const onAuth0LoginButtonClick = () => {
    window.location.href = `${REACT_APP_AUTH0_URL}/authorize?response_type=id_token&client_id=${REACT_APP_AUTH0_CLIENT_ID}&redirect_uri=${window.location.origin}&nonce=blank&scope=openid%20profile%20email`;
  };

  const handleDontHaveAccount = () => {
    window.location.href = 'https://hennessey.com/contact/';
  };

  useEffect(() => {
    // hook that is getting triggered every render
    if (state.auth.isLoggedIn || cookies.id_token) {
      history.push('/');
    }
  });

  if (!phoneEntered) {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          alignItems: 'center',
          justifyContent: 'space-evenly',
          height: '100vh',
          background: 'white',
        }}
      >
        <img src={logo} alt="Hennessey Logo" height="40" />
        <div style={{ height: '60vh', width: '100%' }}>
          <img src={horse} alt="Horse" className={classes.loginImage} />
          <div className={classes.backgroundContent}>
            <div>
              <img
                src={squareLogo}
                className={classes.topLogo}
                alt="Hennessey Second Logo"
                height="80"
              />
              <h1>Transforming Your Traffic Into Conversions</h1>
              <div className={classes.iconContainer}>
                <img src={funnel} alt="Funnel Icon" />
                <img src={charts} alt="Charts Icon" />
                <img src={network} alt="Network Icon" />
                <img src={headset} alt="Headset Icon" />
              </div>
            </div>
          </div>
        </div>
        <BlueButton style={{ width: '80%', height: 55 }} onClick={() => setPhoneEntered(true)}>
          LOG IN
        </BlueButton>
      </div>
    );
  }

  if (isPhone) {
    return (
      <div style={{ background: 'white' }}>
        <MobileTitle title="Log In" />
        <div className={classes.mobileFlex}>
          <form style={{ margin: '0 20px 0 20px' }} noValidate>
            <div className={classes.buttonWrapper}>
              <PrimaryButton
                variant="contained"
                color="primary"
                className={classes.loginSubmitButton}
                onClick={onAuth0LoginButtonClick}
                style={{ width: '100%' }}
                data-testid="login_test_id"
              >
                Login
              </PrimaryButton>
            </div>
          </form>
          <div
            onClick={handleDontHaveAccount}
            className={classes.blackLinkAccount}
            aria-hidden="true"
          >
            Don&apos;t have an account yet?
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <Sidebar>
      
        <Box className={classes.buttonWrapper} style={{ paddingTop: '10px', paddingBottom: '10px'}} >
          <PrimaryButton
            variant="contained"
            color="primary"
            className={classes.loginSubmitButton}
            onClick={onAuth0LoginButtonClick}
            data-testid="login_test_id"
          >
            Login
          </PrimaryButton>
        </Box>
        <div
          onClick={handleDontHaveAccount}
          className={classes.blackLinkAccount}
          aria-hidden="true"
        >
          Don&apos;t have an account yet?
        </div>
        <Divider className={classes.greyColorCustomizer} />
      </Sidebar>

      <GroupImage />
    </>
  );
};

export default Login;
